import { render, staticRenderFns } from "./TraktUser.vue?vue&type=template&id=4523f665&"
import script from "./TraktUser.vue?vue&type=script&lang=js&"
export * from "./TraktUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports